import React from 'react';
import { css } from '@emotion/react';
import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { ScreenGrowIcon, ScreenShrinkIcon } from '$/images/FontAwesomeIcons';
import isMobile from '$/utils/isMobile';
import Button from '../../ui/Button/Button';

const FullScreenButton: React.FC = withWebinarPlayerContext(
  ['currentRoom'],
  'FullScreenButton'
)(({ context }) => {
  const { currentRoom } = context;
  const [isFullscreen, setIsFullscreen] = React.useState(false);

  if (isMobile || !currentRoom.caps.hasVideoPlayer) return null;

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };

  const toggleFullscreen = () => {
    if (document.fullscreenElement === null) {
      document.documentElement.requestFullscreen().catch((e) => {
        exitFullscreen();
        console.error('Error using fullscreen ', { e });
      });
    } else {
      setTimeout(() => {
        exitFullscreen();
      }, 500);
    }
  };

  React.useEffect(() => {
    if (!document) return;

    const fullscreenchanged = (): void => {
      // document.fullscreenElement will point to the element that
      // is in fullscreen mode if there is one. If there isn't one,
      // the value of the property is null.
      if (document.fullscreenElement) {
        setIsFullscreen(true);
        console.log('Fullscreen now in');
      } else {
        setIsFullscreen(false);
        console.log('Leaving fullscreen mode');
      }
    };

    document.addEventListener('fullscreenchange', fullscreenchanged);

    return (): void => {
      document.body.removeEventListener('fullscreenchange', fullscreenchanged);
    };
  }, []);

  return (
    <div className='control mr-4'>
      <Button
        className='appearance-none outline-none view-button'
        css={css`
          > svg {
            height: 1.25rem;
          }
        `}
        small
      >
        {isFullscreen ? (
          <ScreenShrinkIcon onClick={toggleFullscreen} />
        ) : (
          <ScreenGrowIcon onClick={toggleFullscreen} />
        )}
      </Button>
    </div>
  );
});

export default FullScreenButton;
